var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container my-2 p-0"},[_c('b-tabs',{staticClass:"clinic-sub-tabs",attrs:{"justified":"","lazy":""}},[_c('b-tab',{attrs:{"index":"recipes","title":"Talonarios XML"}},[_c('clinic-xml-recipes')],1),_vm._v(" "),_c('b-tab',{attrs:{"index":"pharmaceuticals","title":"Fármacos"}},[_c('clinic-pharmaceuticals')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }